import React from 'react'
import {Routes, Route, useLocation} from 'react-router-dom'
import Home from '../../Pages/Home Page/Home.js'
import About from '../../Pages/About Page/About.js'
import Projects from '../../Pages/Projects/Projects.js'
import Skills from '../../Pages/Skills/Skills.js'
import Contact from '../../Pages/Contact Page/Contact.js'
import {AnimatePresence} from 'framer-motion/dist/framer-motion'


function AnimatedRoutes() {
  const location = useLocation();

  return (
      <AnimatePresence>
        <Routes location={location}  key={location.pathname}>
            <Route path="/" element={<Home/>} />
            <Route path="/About" element={<About/>} />
            <Route path="/Projects" element = {<Projects/>} />
            <Route path="/Skills" element={<Skills/>} />
            <Route path="/Contact" element={<Contact/>} />
        </Routes>
      </AnimatePresence>

  )
}

export default AnimatedRoutes